import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { KeyboardButton } from '../../interfaces/helix-book.interfaces';

@Component({
  selector: 'app-button-keyboard',
  templateUrl: './button-keyboard.component.html',
  styleUrls: ['./button-keyboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, NzToolTipModule],
})
export class ButtonKeyboardComponent {
  @Input() keyboard: KeyboardButton[] = [];
  @Input() activeKey = '';
  @Output() selectedKey = new EventEmitter<string>();

  protected active(key: KeyboardButton): void {
    if (key && !key.disabled) {
      this.selectedKey.emit(key.symbol);
    }
  }
}
